// src/components/schedule/Calendar.js
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Calendar = ({ selectedDate, setSelectedDate, currentWeekStart, setCurrentWeekStart }) => {
    const weekStart = new Date(currentWeekStart);
    const today = new Date();

    // Get array of 7 days (Mon–Sun)
    const getWeekDates = (start) => {
        const dates = [];
        for (let i = 0; i < 7; i++) {
            const d = new Date(start);
            d.setDate(start.getDate() + i);
            dates.push(d);
        }
        return dates;
    };

    const weekDates = getWeekDates(weekStart);

    const formatRange = (start, end) => {
        const startMonth = start.toLocaleString('default', { month: 'short' });
        const endMonth = end.toLocaleString('default', { month: 'short' });
        const sameMonth = startMonth === endMonth;
        return sameMonth
            ? `${startMonth} ${start.getDate()} - ${end.getDate()}, ${start.getFullYear()}`
            : `${startMonth} ${start.getDate()} - ${endMonth} ${end.getDate()}, ${start.getFullYear()}`;
    };

    const handlePrevWeek = () => {
        const prevWeek = new Date(weekStart);
        prevWeek.setDate(weekStart.getDate() - 7);
        setCurrentWeekStart(prevWeek);
    };

    const handleNextWeek = () => {
        const nextWeek = new Date(weekStart);
        nextWeek.setDate(weekStart.getDate() + 7);
        setCurrentWeekStart(nextWeek);
    };

    return (
        <div className="bg-gradient-to-br from-teal-400 to-cyan-500 p-4">
            <h2 className="text-white text-xl font-bold mb-4">Child Schedule</h2>

            {/* Week Navigation */}
            <div className="flex items-center justify-between mb-4">
                <button
                    onClick={handlePrevWeek}
                    className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center backdrop-blur-sm"
                >
                    <ChevronLeft className="w-5 h-5 text-white" />
                </button>
                <div className="text-center text-white">
                    <p className="text-sm font-medium">
                        {formatRange(weekDates[0], weekDates[6])}
                    </p>
                </div>
                <button
                    onClick={handleNextWeek}
                    className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center backdrop-blur-sm"
                >
                    <ChevronRight className="w-5 h-5 text-white" />
                </button>
            </div>

            {/* Weekly Calendar */}
            <div className="bg-white bg-opacity-20 rounded-2xl p-4 backdrop-blur-sm">
                <div className="grid grid-cols-7 gap-2">
                    {weekDates.map((day, idx) => {
                        const isToday = day.toDateString() === today.toDateString();
                        const isSelected = day.toDateString() === selectedDate.toDateString();

                        return (
                            <div key={idx} className="text-center flex justify-center flex-col items-center">
                                <div className="text-white text-xs font-medium opacity-70 mb-2">
                                    {day.toLocaleString('en-US', { weekday: 'short' }).charAt(0)}
                                </div>
                                <button
                                    onClick={() => setSelectedDate(day)}
                                    className={`w-full sm:w-14   aspect-square rounded-xl flex flex-col items-center justify-center text-sm font-semibold transition ${isSelected
                                        ? 'bg-white text-cyan-600 shadow-lg'
                                        : 'text-white hover:bg-white hover:bg-opacity-20'
                                        }`}
                                >
                                    <span className="text-lg">{day.getDate()}</span>
                                    {isToday && <span className="text-xs mt-0.5">Today</span>}
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Calendar;
